module.exports = __webpack_public_path__ + "static/img/useTutorial-bg2.1784115679763.png";